import React, { Component } from 'react';
import { graphql, withApollo } from 'react-apollo';
import { Table, Button, notification, Modal, Input } from 'antd';
import AntIcon from '../shared/components/AntIcon';
import moment from 'moment';

import { ListKeywordsQuery, DeleteKeywordMutation, CreateKeywordMutation } from './queries';

const Columns = (handleDelete) => [
  {
    title: 'Keyword',
    dataIndex: 'value',
    defaultSortOrder: 'descend',
  },
  {
    title: 'Last Cleaned At',
    dataIndex: 'last_cleaned_at',
    defaultSortOrder: 'descend',
    render: (last_cleaned_at) => last_cleaned_at && moment(last_cleaned_at).format("lll"),
  },
  {
    title: "Actions",
    dataIndex: '_id',
    render: (id) => (
      <Button ghost type="danger" onClick={() => handleDelete(id)}>
        <AntIcon type="delete" />Delete
      </Button>
    ),
  }
];

class List extends Component {
  state = {
    modalVisible: false,
    newKeyword: "",
  }

  handleDelete = (id) => {
    const { client, data: { refetch } } = this.props;
    client.mutate({
      mutation: DeleteKeywordMutation,
      variables: { query: { _id: id } },
    }).then(refetch);
  }

  handleCreate = () => {
    const { client, data: { refetch } } = this.props;
    const { newKeyword } = this.state;
    client.mutate({
      mutation: CreateKeywordMutation,
      variables: { keyword: { value: newKeyword } },
    })
    .then(() => {
      refetch();
      this.setState({ 
        modalVisible: false,
        newKeyword: "",
      });
    })
    .catch(error => {
      if (error.message.endsWith("Validation failed")) {
        return notification.error({ message: "Keyword is already exists" });
      }
      notification.error(error);
    });
  }

  render() {
    const { newKeyword, modalVisible } = this.state;
    const { loading, error, Keywords } = this.props.data;
    if (error) return `Error: ${error}`;

    return (
      <div id="keywords-list">
        <div className="container">
          <h4>
            Keywords
            <Button.Group size="small" className="is-right">
              <Button onClick={() => this.setState({ modalVisible: true })} icon="plus">New keyword</Button>
            </Button.Group>
          </h4>
          <Table
            scroll={{ x: 1000 }}
            loading={loading}
            columns={Columns(this.handleDelete)}
            rowKey='_id'
            dataSource={Keywords}
          />
          <Modal
            title="Add New Keyword"
            open={modalVisible}
            onOk={this.handleCreate}
            okText="Add"
            onCancel={() => this.setState({ modalVisible: false })}
          >
            <Input
              value={newKeyword} 
              onChange={(event) => this.setState({ newKeyword: event.target.value })}
              placeholder="Keyword"
            />
          </Modal>
        </div>
      </div>
    );
  }
}

export default withApollo(graphql(ListKeywordsQuery, { options: { fetchPolicy: 'no-cache' } })(List));
